export default __webpack_public_path__ + "static/media/confirmation-image.88ecb9be.jpg";